// src/pages/SignInPage.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import HeaderBar from '../components/HeaderBar';
import Footer from '../components/Footer';
import { apiPost } from '../lib/apiClient';

export default function SignInPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');
    try {
      const res = await apiPost('/api/auth/signin', { username, password });
      setMessage(`Signed in as ${res?.username || username}.`);
      setPassword('');
      // Redirect to main page after a brief confirmation
      setTimeout(() => navigate('/', { replace: true }), 300);
    } catch (err) {
      setError(err?.msg || err?.message || 'Sign in failed. Check your credentials and try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-shell">
      <HeaderBar />
      <main className="auth-page">
        <div className="card" style={{ maxWidth: 420, margin: '32px auto', padding: 24 }}>
          <h2 style={{ marginTop: 0, marginBottom: 12 }}>Sign in</h2>
          <p style={{ marginTop: 0, color: '#4b5563' }}>
            Enter your username and password to continue working in your survey workspace.
          </p>
          <form onSubmit={handleSubmit} style={{ display: 'grid', gap: 12 }}>
            <label style={{ display: 'grid', gap: 4 }}>
              <span>Username</span>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoComplete="username"
              />
            </label>
            <label style={{ display: 'grid', gap: 4 }}>
              <span>Password</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
                autoComplete="current-password"
              />
            </label>
            <button className="btn primary-btn" type="submit" disabled={loading}>
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
          {message && <div style={{ marginTop: 12, color: '#065f46' }}>{message}</div>}
          {error && <div style={{ marginTop: 12, color: '#b91c1c' }}>{error}</div>}
          <div style={{ marginTop: 16, color: '#4b5563' }}>
            Need an account? <Link to="/signup">Create one</Link>
          </div>
          <div style={{ marginTop: 8 }}>
            <Link to="/reset-password">Forgot password?</Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
